import {
    HUE_APARTMENT,
    HUE_BENNETT_LINENS,
    HUE_BENNETT_ROOM,
    HUE_FAMILY,
    HUE_FUTURE,
    HUE_LIZ_LINENS,
    HUE_LIZ_ROOM,
    HUE_MAGIC,
    HUE_MIRIAM_LINENS,
    HUE_OCEAN,
    HUE_PAST,
    HUE_PRESENT,
    HUE_ROOF,
    HUE_SAND,
    HUE_SNOW,
    HUE_TENNIS,
    HUE_WAITING,
} from '../../../../scss/exports/style.module'

import {
    APARTMENT_EVENING_COLOUR,
    APARTMENT_NIGHT_COLOUR,
    BANCROFT_EXTERIOR_COLOUR,
    BANCROFT_GATE_COLOUR,
    BASEMENT_CEILING_COLOUR,
    BENNETT_BED_COLOUR,
    BENNETT_BED_DIM_COLOUR,
    BENNETT_CARPET_COLOUR,
    BENNETT_CARPET_DIM_COLOUR,
    BENNETT_COUCH_COLOUR,
    BENNETT_FLOOR_COLOUR,
    BENNETT_WALL_COLOUR,
    BENNETT_WALL_DIM_COLOUR,
    CINEMA_EXTERIOR_COLOUR,
    CLUB_FRONT_PRIMARY_COLOUR,
    CLUB_FRONT_SECONDARY_COLOUR,
    CLUB_SIDE_PRIMARY_COLOUR,
    CLUB_SIDE_SECONDARY_COLOUR,
    CONCRETE_PLATFORM_COLOUR,
    CONCRETE_PLATFORM_EVENING_COLOUR,
    CONCRETE_PLATFORM_NIGHT_COLOUR,
    CROSSWALK_COLOUR,
    CROSSWALK_NIGHT_COLOUR,
    DARK_ROOM_COLOUR,
    DEATHBED_FLOOR_COLOUR,
    DEFAULT_CLEAR_COLOUR,
    DIRT_FLOOR_COLOUR,
    FAMILY_EXTERIOR_COLOUR,
    FANCY_WALL_COLOUR,
    FURNITURE_PLATFORM_COLOUR,
    FUTURE_PLATFORM_COLOUR,
    FUTURE_SPOTLIGHT_LIGHTER_COLOUR,
    FUTURE_SPOTLIGHT_LIGHTEST_COLOUR,
    FUTURE_SPOTLIGHT_LIGHT_COLOUR,
    FUTURE_SPOTLIGHT_MEDIUM_COLOUR,
    GENERIC_EVENING_COLOUR,
    GENERIC_EXTERIOR_COLOUR,
    GENERIC_NIGHT_COLOUR,
    GRASS_AUTUMN_COLOUR,
    GRASS_AUTUMN_EVENING_COLOUR,
    GRASS_AUTUMN_NIGHT_COLOUR,
    GRASS_COLOUR,
    GRASS_EVENING_COLOUR,
    GRASS_NIGHT_COLOUR,
    GRASS_WINTER_EVENING_COLOUR,
    GROUND_CLEAR_COLOUR,
    INDUSTRIAL_WALL_COLOUR,
    LINOLEUM_FLOOR_COLOUR,
    LINOLEUM_PAST_COLOUR,
    LIZ_BED_COLOUR,
    LIZ_COUCH_COLOUR,
    LIZ_EVENING_COLOR,
    LIZ_FLOOR_COLOUR,
    LIZ_GATE_COLOUR,
    LIZ_GATE_EVENING_COLOUR,
    LIZ_GATE_NIGHT_COLOUR,
    LIZ_WALL_COLOUR,
    MAGIC_COLOUR,
    MIRIAM_COUCH_COLOUR,
    NIGHT_FUTURE_COLOUR,
    OCEAN_NIGHT_COLOUR,
    OLD_FLOOR_COLOUR,
    PAST_PLATFORM_COLOUR,
    PAVEMENT_COLOUR,
    PAVEMENT_EVENING_COLOUR,
    PAVEMENT_NIGHT_COLOUR,
    PLATFORM_COLOUR,
    PLATFORM_EVENING_COLOUR,
    PRESENT_PLATFORM_COLOUR,
    ROOF_COLOUR,
    ROOF_EVENING_COLOUR,
    ROOF_NIGHT_COLOUR,
    SAND_NIGHT_COLOUR,
    SCHOOL_FLOOR_COLOUR,
    SCHOOL_WALL_COLOUR,
    SNOW_FLOOR_COLOUR,
    SOFT_WALL_COLOUR,
    SPOTLIGHT_LIGHTER_COLOUR,
    SPOTLIGHT_LIGHTEST_COLOUR,
    SPOTLIGHT_LIGHT_COLOUR,
    SPOTLIGHT_MEDIUM_COLOUR,
    STREET_COLOUR,
    STREET_EVENING_COLOUR,
    STREET_NIGHT_COLOUR,
    TAIWAN_GATE_NIGHT_COLOUR,
    TAIWAN_WALL_NIGHT_COLOUR,
    TENNIS_COLOUR,
    UNDERGROUND_WALL_COLOUR,
    VAN_NUYS_EXTERIOR_COLOUR,
    VELVET_FLOOR_COLOUR,
    WAITING_ARMCHAIR_COLOUR,
    WOOD_FLOOR_COLOUR,
} from '../colours'

export default {
    /* D. */
    [DEFAULT_CLEAR_COLOUR]: { h: 0, s: 0, l: 100, a: 0.2 },
    /* G. */
    [GROUND_CLEAR_COLOUR]: { h: 0, s: 0, l: 0, a: 0.2 },
    /* H. */
    [GRASS_EVENING_COLOUR]: { h: 100, s: 23, l: 29 },
    [GRASS_NIGHT_COLOUR]: { h: 100, s: 28, l: 34 },
    [GRASS_COLOUR]: { h: 100, s: 33, l: 39 },
    [GRASS_AUTUMN_COLOUR]: { h: 70, s: 28, l: 39 },
    [GRASS_AUTUMN_EVENING_COLOUR]: { h: 70, s: 23, l: 34 },
    [GRASS_AUTUMN_NIGHT_COLOUR]: { h: 70, s: 18, l: 29 },
    [GRASS_WINTER_EVENING_COLOUR]: { h: 182, s: 23, l: 56 },
    /* T. */
    [STREET_COLOUR]: { h: 0, s: 0, l: 39 },
    [STREET_EVENING_COLOUR]: { h: 0, s: 0, l: 34 },
    [STREET_NIGHT_COLOUR]: { h: 0, s: 0, l: 29 },
    /* V. */
    [OCEAN_NIGHT_COLOUR]: { h: parseInt(HUE_OCEAN), s: 36, l: 32 },
    [PAVEMENT_COLOUR]: { h: 0, s: 0, l: 61 },
    [PAVEMENT_EVENING_COLOUR]: { h: 0, s: 0, l: 56 },
    [PAVEMENT_NIGHT_COLOUR]: { h: 0, s: 0, l: 51 },
    [TENNIS_COLOUR]: { h: parseInt(HUE_TENNIS), s: 51, l: 55 },
    /* K. */
    [SAND_NIGHT_COLOUR]: { h: parseInt(HUE_SAND), s: 12, l: 42 },
    [CROSSWALK_COLOUR]: { h: 48, s: 6, l: 82 },
    [CROSSWALK_NIGHT_COLOUR]: { h: 48, s: 4, l: 62 },
    /* C. */
    [ROOF_COLOUR]: { h: parseInt(HUE_ROOF), s: 24, l: 51 },
    [ROOF_EVENING_COLOUR]: { h: parseInt(HUE_ROOF), s: 19, l: 46 },
    [ROOF_NIGHT_COLOUR]: { h: parseInt(HUE_ROOF), s: 14, l: 41 },
    [BASEMENT_CEILING_COLOUR]: { h: 23, s: 19, l: 57 }, // Same as maple colour.
    /* F. */
    [BENNETT_CARPET_COLOUR]: { h: parseInt(HUE_BENNETT_ROOM), s: 25, l: 57 },
    [BENNETT_CARPET_DIM_COLOUR]: { h: parseInt(HUE_BENNETT_ROOM), s: 20, l: 42 },
    [BENNETT_FLOOR_COLOUR]: { h: parseInt(HUE_BENNETT_ROOM) + 15, s: 15, l: 69 },
    [LIZ_FLOOR_COLOUR]: { h: parseInt(HUE_LIZ_ROOM) + 15, s: 22, l: 59 },
    [WOOD_FLOOR_COLOUR]: { h: 32, s: 45, l: 34 },
    [OLD_FLOOR_COLOUR]: { h: 36, s: 13, l: 46 },
    [DIRT_FLOOR_COLOUR]: { h: 51, s: 12, l: 34 },
    [LINOLEUM_FLOOR_COLOUR]: { h: 74, s: 14, l: 67 },
    [DEATHBED_FLOOR_COLOUR]: { h: 84, s: 14, l: 67 },
    [SCHOOL_FLOOR_COLOUR]: { h: 346, s: 13, l: 72 },
    [VELVET_FLOOR_COLOUR]: { h: 357, s: 44, l: 36 },
    [SNOW_FLOOR_COLOUR]: { h: parseInt(HUE_SNOW), s: 30, l: 87 },
    /* Z. */
    [LINOLEUM_PAST_COLOUR]: { h: parseInt(HUE_PAST), s: 14, l: 67 },
    [MAGIC_COLOUR]: { h: parseInt(HUE_MAGIC), s: 17, l: 25 },
    [DARK_ROOM_COLOUR]: { h: 221, s: 17, l: 34 },
    [NIGHT_FUTURE_COLOUR]: { h: 276, s: 17, l: 25 },
    /* L, M, N, O. */
    [SPOTLIGHT_MEDIUM_COLOUR]: { h: 77, s: 19, l: 35, a: 0.9 },
    [SPOTLIGHT_LIGHT_COLOUR]: { h: 69, s: 23, l: 45, a: 0.8 },
    [SPOTLIGHT_LIGHTER_COLOUR]: { h: 64, s: 36, l: 55, a: 0.7 },
    [SPOTLIGHT_LIGHTEST_COLOUR]: { h: 62, s: 58, l: 65, a: 0.6 },
    [FUTURE_SPOTLIGHT_MEDIUM_COLOUR]: { h: 48, s: 19, l: 35, a: 0.9 },
    [FUTURE_SPOTLIGHT_LIGHT_COLOUR]: { h: 58, s: 23, l: 45, a: 0.8 },
    [FUTURE_SPOTLIGHT_LIGHTER_COLOUR]: { h: 61, s: 36, l: 55, a: 0.7 },
    [FUTURE_SPOTLIGHT_LIGHTEST_COLOUR]: { h: 62, s: 58, l: 65, a: 0.6 },
    /* W, B, E */
    [BENNETT_WALL_COLOUR]: { h: parseInt(HUE_BENNETT_ROOM), s: 15, l: 81 },
    [BENNETT_WALL_DIM_COLOUR]: { h: parseInt(HUE_BENNETT_ROOM), s: 14, l: 66 },
    [LIZ_WALL_COLOUR]: { h: parseInt(HUE_LIZ_ROOM), s: 15, l: 81 },
    [UNDERGROUND_WALL_COLOUR]: { h: 41, s: 18, l: 65 },
    [SOFT_WALL_COLOUR]: { h: 68, s: 31, l: 87 },
    [INDUSTRIAL_WALL_COLOUR]: { h: 96, s: 13, l: 77 },
    [CLUB_FRONT_PRIMARY_COLOUR]: { h: 221, s: 23, l: 65 },
    [CLUB_FRONT_SECONDARY_COLOUR]: { h: 141, s: 21, l: 58 },
    [CLUB_SIDE_PRIMARY_COLOUR]: { h: 355, s: 23, l: 65 },
    [CLUB_SIDE_SECONDARY_COLOUR]: { h: 55, s: 21, l: 58 },
    [FANCY_WALL_COLOUR]: { h: 278, s: 13, l: 76 },
    [SCHOOL_WALL_COLOUR]: { h: 334, s: 17, l: 78 },
    /* X. */
    [APARTMENT_EVENING_COLOUR]: { h: parseInt(HUE_APARTMENT), s: 11, l: 53 },
    [APARTMENT_NIGHT_COLOUR]: { h: parseInt(HUE_APARTMENT), s: 6, l: 48 },
    [FAMILY_EXTERIOR_COLOUR]: { h: parseInt(HUE_FAMILY), s: 24, l: 78 },
    [LIZ_EVENING_COLOR]: { h: parseInt(HUE_LIZ_ROOM), s: 8, l: 67 },
    [GENERIC_EXTERIOR_COLOUR]: { h: 12, s: 16, l: 65 },
    [GENERIC_EVENING_COLOUR]: { h: 12, s: 12, l: 60 },
    [GENERIC_NIGHT_COLOUR]: { h: 12, s: 8, l: 55 },
    [BANCROFT_EXTERIOR_COLOUR]: { h: 102, s: 6, l: 68 },
    [CINEMA_EXTERIOR_COLOUR]: { h: 143, s: 14, l: 68 },
    [TAIWAN_WALL_NIGHT_COLOUR]: { h: 208, s: 18, l: 55 },
    [VAN_NUYS_EXTERIOR_COLOUR]: { h: 334, s: 14, l: 63 },
    /* A. */
    [TAIWAN_GATE_NIGHT_COLOUR]: { h: 35, s: 5, l: 37 },
    [LIZ_GATE_COLOUR]: { h: 46, s: 12, l: 52 },
    [LIZ_GATE_EVENING_COLOUR]: { h: 46, s: 9, l: 47 },
    [LIZ_GATE_NIGHT_COLOUR]: { h: 46, s: 6, l: 42 },
    [BANCROFT_GATE_COLOUR]: { h: 102, s: 4, l: 59 },
    /* P. */
    [CONCRETE_PLATFORM_COLOUR]: { h: 220, s: 14, l: 69 },
    [CONCRETE_PLATFORM_EVENING_COLOUR]: { h: 220, s: 11, l: 64 },
    [CONCRETE_PLATFORM_NIGHT_COLOUR]: { h: 220, s: 9, l: 59 },
    [PLATFORM_COLOUR]: { h: 13, s: 16, l: 33 },
    [PLATFORM_EVENING_COLOUR]: { h: 13, s: 11, l: 28 },
    [PAST_PLATFORM_COLOUR]: { h: parseInt(HUE_PAST), s: 33, l: 57 },
    [PRESENT_PLATFORM_COLOUR]: { h: parseInt(HUE_PRESENT), s: 33, l: 57 },
    [FUTURE_PLATFORM_COLOUR]: { h: parseInt(HUE_FUTURE), s: 33, l: 57 },
    [FURNITURE_PLATFORM_COLOUR]: { h: 30, s: 23, l: 42 },
    /* U. */
    [BENNETT_COUCH_COLOUR]: { h: parseInt(HUE_BENNETT_LINENS), s: 25, l: 45 },
    [BENNETT_BED_COLOUR]: { h: parseInt(HUE_BENNETT_LINENS), s: 35, l: 60 },
    [BENNETT_BED_DIM_COLOUR]: { h: parseInt(HUE_BENNETT_LINENS), s: 25, l: 45 },
    [LIZ_COUCH_COLOUR]: { h: parseInt(HUE_LIZ_LINENS), s: 15, l: 50 },
    [LIZ_BED_COLOUR]: { h: parseInt(HUE_LIZ_LINENS) + 20, s: 25, l: 65 },
    [WAITING_ARMCHAIR_COLOUR]: { h: parseInt(HUE_WAITING), s: 34, l: 44 },
    [MIRIAM_COUCH_COLOUR]: { h: parseInt(HUE_MIRIAM_LINENS), s: 25, l: 45 },
}
